import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import axios from "axios";

const Events = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [eventTitle, setEventTitle] = useState("");
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Retrieve sessionId from localStorage
  const sessionId = localStorage.getItem("currentSessionId");

  // If sessionId doesn't exist in localStorage, alert the user
  if (!sessionId) {
    alert("Session ID is not available in localStorage. Please log in or select a session.");
    // You could redirect to a login or session selection page here
  }

  // Fetch events
  // Fetch events
const fetchEvents = async () => {
  if (!sessionId) return alert("No session selected. Please select a session first.");

  try {
    setLoading(true);
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/events/getEvents/${sessionId}`);
    setEvents(res.data);
    setError(null);
  } catch (err) {
    setError("Failed to load events.");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchEvents();
  }, []);

  
  const handleAddEvent = async () => {
    if (!eventTitle.trim()) return alert("Event title cannot be empty");
    if (!sessionId) return alert("No session selected. Please select a session first.");

    const newEvent = {
      title: eventTitle,
      date: selectedDate.toISOString(), // send ISO string
      sessionId: sessionId, // Use sessionId from localStorage
    };

    try {
      setLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/events/createEvent`, newEvent);
      setEvents([...events, res.data]); // Update immediately
      setEventTitle("");
      setError(null);
      alert("Event added successfully");
    } catch (err) {
      setError("Failed to add event.");
    } finally {
      setLoading(false);
    }
  };

  // Delete event
  const handleDeleteEvent = async (id) => {
    if (!window.confirm("Are you sure you want to delete this event?")) return;
    try {
      setLoading(true);
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/events/deleteEvent/${id}`);
      setEvents(events.filter((e) => e._id !== id));
      alert("Event deleted successfully");
    } catch (err) {
      setError("Failed to delete event.");
    } finally {
      setLoading(false);
    }
  };

  const sortedEvents = [...events].sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-xl font-bold mb-6">Event Calendar</h1>
      <hr />
      <br />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Calendar */}
        <div className="bg-white p-5 rounded-lg shadow flex flex-col items-center">
          <Calendar onChange={setSelectedDate} value={selectedDate} />
          <p className="mt-4 text-center">
            Selected Date: <strong>{selectedDate.toDateString()}</strong>
          </p>
        </div>

        {/* Add Event */}
        <div className="bg-white p-5 rounded-lg shadow">
          <h3 className="text-2xl font-semibold mb-4">Add New Event</h3>

          <input
            type="text"
            placeholder="Enter Event Title"
            className="w-full p-3 mb-4 rounded-lg border"
            value={eventTitle}
            onChange={(e) => setEventTitle(e.target.value)}
          />
          <button
            onClick={handleAddEvent}
            disabled={loading}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-lg"
          >
            {loading ? "Adding Event..." : "Add Event"}
          </button>
          {error && <p className="text-red-500 mt-3">{error}</p>}
        </div>
      </div>

      <h2 className="text-xl font-bold mt-12 mb-6">Upcoming Events</h2>
      <hr />
      <br />

      {loading ? (
        <p>Loading events...</p>
      ) : sortedEvents.length > 0 ? (
        <table className="min-w-full border rounded-lg">
          <thead className="bg-gray-200">
            <tr>
              <th className="py-2 px-4 border">Sr.</th>
              <th className="py-2 px-4 border">Title</th>
              <th className="py-2 px-4 border">Date</th>
              <th className="py-2 px-4 border">Action</th>
            </tr>
          </thead>
          <tbody>
            {sortedEvents.map((e, i) => (
              <tr key={e._id} className="border-b hover:bg-gray-100">
                <td className="py-2 px-4">{i + 1}</td>
                <td className="py-2 px-4">{e.title}</td>
                <td className="py-2 px-4">{new Date(e.date).toDateString()}</td>
                <td className="py-2 px-4">
                  <button
                    onClick={() => handleDeleteEvent(e._id)}
                    className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-500"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No events found.</p>
      )}
    </div>
  );
};

export default Events;